import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { getRecebivelDropdownPt } from '../shared/PrimeDropdownProps.js';

/**
 * @typedef {object} RecebivelDiscountSectionProps
 * @property {string} recebivelTipoDescontoTipo
 * @property {(value: string) => void} setRecebivelTipoDescontoTipo
 * @property {string|number|null} recebivelTipoDesconto
 * @property {(value: string|number|null) => void} setRecebivelTipoDesconto
 * @property {{label: string, value: string}[]} descontoOptions
 */

/**
 * Bloco de configuracao de desconto do formulario de recebivel.
 *
 * @param {RecebivelDiscountSectionProps} props
 * @returns {JSX.Element}
 */
export default function RecebivelDiscountSection(props) {
    const {
        recebivelTipoDescontoTipo,
        setRecebivelTipoDescontoTipo,
        recebivelTipoDesconto,
        setRecebivelTipoDesconto,
        descontoOptions,
    } = props;

    return (
        <div className="w-full flex flex-col items-center justify-center border-2 border-blue-200 mt-1 p-2" style={{ borderRadius: '1rem' }}>
            <div className='flex md:flex-row flex-col w-full gap-4'>
                <div className="flex flex-col w-full md:w-1/2">
                    <label htmlFor="recebivel_tipo_desconto_tipo" className='mt-2 mb-2'>Tipo de desconto</label>
                    <Dropdown
                        id='recebivel_tipo_desconto_tipo'
                        value={recebivelTipoDescontoTipo}
                        options={descontoOptions}
                        onChange={(e) => { setRecebivelTipoDescontoTipo(e.target.value); }}
                        pt={getRecebivelDropdownPt()}
                    />
                </div>
                <div className="flex flex-col w-full md:w-1/2">
                    <label htmlFor="recebivel_tipo_desconto" className='mt-2 mb-2'>Valor do Desconto</label>
                    <InputText
                        id="recebivel_tipo_desconto"
                        placeholder="ex: 1111"
                        value={recebivelTipoDesconto}
                        onChange={(e) => setRecebivelTipoDesconto(e.target.value)}
                        type="number"
                        min={0}
                    />
                </div>
            </div>
            <div className='w-full mt-2'>
                <p className='px-3 font-bold text-xs'>*Este desconto será dado ao Valor do boleto após gerado.</p>
            </div>
        </div>
    );
}
